import { render, staticRenderFns } from "./weixing.vue?vue&type=template&id=2356f3ea&"
import script from "./weixing.vue?vue&type=script&lang=js&"
export * from "./weixing.vue?vue&type=script&lang=js&"
import style0 from "./weixing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports